<template>
  <!--
    One row per what-if / replay message, in the order the API returned them.
    This used to be v-stepper-item buttons: Vuetify 4 lays those out as
    inline-flex boxes on a single line inside an overflow-hidden sheet, so a
    multi-line message hung above the baseline and lost its top half, and the
    global button rule title-cased the text.
  -->
  <ol class="replay-messages" data-testid="replay-messages">
    <li
      v-for="(message, index) in replayMessages"
      :key="index"
      class="replay-message"
      :class="{ 'replay-message--error': isErrorMessage(message) }"
      :data-testid="`replay-message-${index}`"
    >
      <v-icon
        class="replay-message__icon"
        size="small"
        :color="isErrorMessage(message) ? 'heatColor' : 'greenGraph'"
      >
        {{ isErrorMessage(message) ? 'mdi-alert-circle' : 'mdi-check-circle' }}
      </v-icon>
      <p class="replay-message__text">{{ message.message }}</p>
    </li>
  </ol>
</template>
<script setup lang="ts">
import { IMessage } from '@/Core.Service.Domain/Strategies/Strategies/types/replayStrategy.ts';

defineProps<{
  replayMessages: IMessage[];
}>();

const isErrorMessage = (message: IMessage) => {
  return message.messageType === 'Error';
};
</script>
<style lang="scss" scoped>
.replay-messages {
  list-style: none;
  margin: 0;
  padding: 8px 12px;
}

.replay-message {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 8px 0;

  & + & {
    border-top: 1px solid rgba(0, 0, 0, 0.12);
  }
}

.replay-message__icon {
  flex: 0 0 auto;
  margin-top: 2px;
}

.replay-message__text {
  flex: 1 1 auto;
  min-width: 0;
  margin: 0;
  text-align: left;
  font-size: 16px;
  color: $primary;
  // The API separates the message's lines with \n; keep them.
  white-space: pre-line;
  overflow-wrap: anywhere;
}
</style>
